import React from 'react';
import { motion } from 'framer-motion';
import { handleCheckoutClick, CHECKOUT_URL } from '../lib/pixel';
export function Hero() {
  return <section className="bg-[var(--color-cream)] py-16 lg:py-28 relative overflow-hidden" data-id="element-77">
      {/* Subtle background decorative element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[var(--color-pale-pink)] opacity-30 rounded-l-full blur-3xl -z-10 transform translate-x-1/3" data-id="element-78"></div>

      <div className="container mx-auto px-6 lg:px-12" data-id="element-79">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-80">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl" data-id="element-81">
            <div className="inline-flex items-center gap-2 bg-[var(--color-sage)] text-white px-5 py-2 rounded-full text-xs font-semibold tracking-wider mb-8 uppercase" data-id="element-82">
              GUÍA DIGITAL · DESCARGA INMEDIATA
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold text-[var(--color-charcoal)] leading-tight mb-6" data-id="element-83">
              Código Hormonal 40+
            </h1>

            <h2 className="text-2xl lg:text-3xl font-medium text-[var(--color-charcoal)] leading-snug mb-6" data-id="element-84">
              La guía de bienestar diseñada para mujeres que quieren recuperar
              su energía y sentirse ligeras de nuevo.
            </h2>

            <p className="text-lg lg:text-xl text-[var(--color-charcoal)] opacity-80 font-light mb-8 leading-relaxed" data-id="element-85">
              Deja de luchar contra tu cuerpo y empieza a trabajar con él. Un
              enfoque natural para esta nueva etapa.
            </p>

            <div className="flex items-baseline gap-3 mb-5" data-id="element-86">
              <span className="text-[var(--color-charcoal)] opacity-40 line-through text-xl" data-id="element-87">
                $27.00
              </span>
              <span className="text-3xl lg:text-4xl font-bold text-[var(--color-charcoal)]" data-id="element-88">
                $8.49
              </span>
              <span className="text-[var(--color-charcoal)] opacity-60 text-sm" data-id="element-89">
                USD
              </span>
            </div>

            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="block text-center w-full lg:w-auto lg:inline-block bg-[var(--color-charcoal)] text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-[var(--color-dark-sage)] transition-colors shadow-sm mb-4" data-id="element-90">
              Quiero mi guía — $8.49 →
            </a>

            <div className="text-[var(--color-charcoal)] opacity-60 text-sm text-center lg:text-left mt-2 space-y-0.5" data-id="element-91">
              <p data-id="element-92">Pago seguro · Descarga inmediata</p>
              <p data-id="element-93">Garantía de satisfacción</p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="relative" data-id="element-94">
            <div className="relative" data-id="element-95">
              <img src="https://cdn.magicpatterns.com/uploads/jNNLSVreiqp6nhEuHTGPyV/Imagen.png" alt="Mujer latina sonriente sosteniendo una tablet con el eBook Código Hormonal 40+ en una cocina luminosa" className="w-full h-auto rounded-2xl" data-id="element-96" />
              <div className="absolute -top-4 -right-4 bg-white text-[var(--color-charcoal)] px-4 py-2 rounded-full text-sm font-semibold shadow-lg border border-[var(--color-pale-pink)]" data-id="element-97">
                +1,200 mujeres lo completaron ⭐
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}